export var companyListMixin = {
    data : () => ({
        companyListQuery: {codigo: '', nome: '', data: '', vendedor: '', filtro: 'avencer', page: 1, todos: null},
        selectedHeaderOptions : [{
            text:'CODIGO',
            value:'CODIGO'
        },
        {
            text: 'NOME',
            value: 'empresa.NOME'
        },
        {
            text: 'TÍTULO',
            value: 'NOME'
        },
        {
            text: 'DATA',
            value: 'DATA'
        },
        {
            text: 'VENDEDOR',
            value: 'vendedor.NOME'
        },
        {
            text: 'DATA INCLUSÃO',
            value: 'DATAINCLUSAO'
        },
        {
            text: 'Ações',
            value: "controls",
            align: 'right'
        }],
    })
}